var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/layout/layout.tsx";
import classNames from 'clsx';
import React from 'react';
import StickyBox from 'react-sticky-box';

/** Layout container, to hold Sidebar, Main, and Aside. */
const Layout = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "sm:pt-4 relative",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-3xl mx-auto sm:px-6 md:max-w-7xl md:px-8 md:grid md:grid-cols-12 md:gap-8",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 5
    }
  }, children));
};
/** Left sidebar container in the UI. */


const Sidebar = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block lg:col-span-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(StickyBox, {
    offsetTop: 80,
    className: "pb-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 5
    }
  }, children));
};
/** Center column container in the UI. */


const Main = _ref3 => {
  let {
    children,
    className
  } = _ref3;
  return /*#__PURE__*/React.createElement("main", {
    className: classNames({
      'md:col-span-12 lg:col-span-9 xl:col-span-6 pb-36': true
    }, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 3
    }
  }, children);
};
/** Right sidebar container in the UI. */


const Aside = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/React.createElement("aside", {
    className: "hidden xl:block xl:col-span-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(StickyBox, {
    offsetTop: 80,
    className: "space-y-6 pb-12",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 5
    }
  }, children));
};

Layout.Sidebar = Sidebar;
Layout.Main = Main;
Layout.Aside = Aside;
export default Layout;